import React, { useState } from "react";
import { images } from "../../assets/images";
import { NavLink, Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { IDashboardLayputProps, IPaginationInfo } from "../../interfaces/pagination-info.interface";
import DashboardIcon from "../../assets/images/d-icon/dashboard.svg";
import Userdata from "../../assets/images/d-icon/userdata.svg";
import Usergroup from "../../assets/images/d-icon/usergroup.svg";
import Updates from "../../assets/images/d-icon/updatestwo.svg";
import Events from "../../assets/images/d-icon/events.svg";
import Logo from "../../assets/images/d-icon/logo.svg";
import {useTranslation} from "react-i18next";

export const DashboardLayout: React.FC<IDashboardLayputProps> = (props) => {
  const [sideBarToggle, setSideBarToggle] = useState(false);
  const [rightSideChatToggle, setRightSideChatToggle] = useState(false);
  useState<IPaginationInfo>({
    currentPage: 0,
    pages: 0,
    perPage: 0,
    totalRecords: 0,
  });
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const { t } = useTranslation('', { keyPrefix: 'DashboardLayout' });

  return (
    <div
      className={`up-wrapper up-wrappertwo ${sideBarToggle ? "up-openclose-sidebar-menu" : ""
        } ${rightSideChatToggle ? "up-opensidebarchat" : ""} `}
    >
      <header id="up-header" className="up-header up-headerdashboard">
        <div className="up-headercontent">
          <h2>{props?.orgName?.replace(/%20/g, " ") || ''}</h2>
        </div>
        <span className="up-menuiconholder">
          <button
            onClick={() => setSideBarToggle(!sideBarToggle)}
            className="up-btnmenuicon"
            type="button"
          >
            <img src={images.MenuIcon} alt="Menu Icon" />
          </button>
        </span>
      </header>
      <div className="up-sidebarwrapper up-sidebardashboard">
        <span className="up-menuiconholder">
          <button
            onClick={() => setSideBarToggle(!sideBarToggle)}
            className="up-btnmenuicon"
            type="button"
          >
            <img src={images.MenuIcon} alt="Menu Icon" />
          </button>
        </span>
        <strong className="up-logo">
          <Link to={`/organization-profile/${props.id}`}>
            <img src={Logo} alt="Logo Image" />
          </Link>
        </strong>
        <nav className="navigation">
          <ul className="nav_list">
            <li className="list-item" data-tooltip="Dashboard">
              <NavLink className={isActive =>
                "nav-link" + (isActive ? " up-active" : "")
              } to={{ pathname: `/dashboard/${props.id}`, search: props.orgName }}>
                <img src={DashboardIcon} alt="dashboard icon" />
                <em>{t('dashboard')}</em>
              </NavLink>
            </li>
            <li className="list-item" data-tooltip="User Data">
              <NavLink className={isActive =>
                "nav-link" + (isActive ? " up-active" : "")
              } to={{ pathname: `/dashboard-users/${props.id}`, search: props.orgName }}>
                <img src={Userdata} alt="user icon" />
                <em>{t('userData')}</em>
              </NavLink>
            </li>
            <li className="list-item" data-tooltip="User Groups">
              <NavLink className={isActive =>
                "nav-link" + (isActive ? " up-active" : "")
              } to={{ pathname: `/dashboard-user-groups/${props.id}`, search: props.orgName }}>
                <img src={Usergroup} alt="usergroup icon" />
                <em>{t('userGroups')}</em>
              </NavLink>
            </li>
            <li className="list-item" data-tooltip="Updates">
              <NavLink className={isActive =>
                "nav-link" + (isActive ? " up-active" : "")
              } to={{ pathname: `/dashboard-updates/${props.id}`, search: props.orgName }}>
                <img src={Updates} alt="updates icon" />
                <em>{t('updates')}</em>
              </NavLink>
            </li>
            <li className="list-item" data-tooltip="Events">
              <NavLink className={isActive =>
                "nav-link" + (isActive ? " up-active" : "")
              } to={{ pathname: `/dashboard-events/${props.id}`, search: props.orgName }}>
                <img src={Events} alt="event icon" />
                <em>{t('events')}</em>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
      <main className="up-main">{props.children}</main>


      <Modal
        className="up-thememodal up-modalreport"
        show={show}
        onHide={handleClose}
      >
        <Modal.Header className="up-modalheader" closeButton>
          <Modal.Title>Change Language</Modal.Title>
        </Modal.Header>
        <Modal.Body className="up-modalbody">
          <div className="up-modalcontentholder">
            <form className="up-formtheme up-formreport">
              <fieldset>
                <ul className="up-reportoptions">
                  <li>
                    <div className="up-reportoption">
                      <span>English</span>
                      <div className="up-radio">
                        <input
                          type="radio"
                          name="report-option"
                          id="up-optionone"
                        />
                        <label htmlFor="up-optionone"></label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="up-reportoption">
                      <span>Dutch</span>
                      <div className="up-radio">
                        <input
                          type="radio"
                          name="report-option"
                          id="up-optiontwo"
                        />
                        <label htmlFor="up-optiontwo"></label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="up-reportoption">
                      <span>French</span>
                      <div className="up-radio">
                        <input
                          type="radio"
                          name="report-option"
                          id="up-optionthree"
                        />
                        <label htmlFor="up-optionthree"></label>
                      </div>
                    </div>
                  </li>
                </ul>
              </fieldset>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
